import { __decorate } from "tslib";
import ModalMixin from "@/mixins/modal-mixin";
import { modalMixins } from "@/mixins/modal.js";
import { Component } from "vue-property-decorator";
import { mapGetters } from "vuex";
let CompanyPrintHeader = class CompanyPrintHeader extends ModalMixin {
    getMyCompany;
    get billing() {
        return { ...this.company.billing, avatar: this.company.avatar };
    }
    get company() {
        return this.getMyCompany("mine");
    }
};
CompanyPrintHeader = __decorate([
    Component({
        mixins: [modalMixins],
        methods: {},
        computed: {
            ...mapGetters("my-company", { getMyCompany: "get" }),
        }
    })
], CompanyPrintHeader);
export default CompanyPrintHeader;
